import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms an integer to a string representing its English ordinal state. For example, the integer `3` becomes `"3rd"`.
 */
@Pipe({
    name: 'nth'
})
export class NthPipe implements PipeTransform {

	/**
	 * A pipe which transforms an integer to a string representing its English ordinal state. For example, the integer `3` becomes `"3rd"`.
	 * @param n the numeric cardinal integer to be converted
	 * @returns the shortform English ordinal number which matches `n`
	 */
	transform(n: number): string {
		/** All numbers from 4 to 20 inclusive end in "th" */
		if (n > 3 && n < 21) {return `${n}th`; } // thanks kennebec

		/** Otherwise check final digit */
		switch (n % 10) {
		case 1:
			/** Append "st" if final digit is 1 */
			return `${n}st`;
		case 2:
			/** Append "nd" if final digit is 2 */
			return `${n}nd`;
		case 3:
			/** Append "rd" if final digit is 3 */
			return `${n}rd`;
		default:
			/** Append "th" in all other cases */
			return `${n}th`;
		}
	}

}
